import { format, getMonth } from 'date-fns'

export function formatXAxisValue(date: Date, index: number, all: Date[]): string {
  const previousDate = index > 0 ? all[index - 1] : null

  return !previousDate || getMonth(date) !== getMonth(previousDate) ? format(date, 'MMM d') : format(date, 'd')
}

export function formatToolTip(date: Date, iterationNumber: number): string {
  const dateStr = format(date, 'MMM d')
  return `${dateStr} Iteration (#${iterationNumber})`
}

export function formatIterationDate(iteration: IterationSummary, index: number, all: IterationSummary[]): string {
  return formatXAxisValue(
    new Date(iteration.start),
    index,
    all.map((i) => new Date(i.start)),
  )
}

export function formatTooltipHeader(iteration: IterationSummary): string {
  return formatToolTip(new Date(iteration.start), iteration.number)
}
